export default __webpack_public_path__ + "static/media/naidi-1-5.8d027a39.svg";